/**
 * Formats an E.164 phone number. US numbers are formatted as "(xxx) xxx-xxxx",
 * other countries are left as-is.
 */
export default function formatPhoneNumber(e164number: string): string {
  if (!e164number || !e164number.match(/\+?1\d{10}/)) {
    return e164number;
  }

  if (e164number.match(/^\+1/)) {
    e164number = e164number.substr(1);
  }

  return `(${e164number.slice(1, 4)}) ${e164number.slice(
    4,
    7
  )}-${e164number.slice(7)}`;
}
